import React, {} from "react";
import useScreenDetector from "@/hooks/useScreenDetector";
import styles from "./style.less";
const Box = ({ children, width = undefined }) => {
    const { isDesktop } = useScreenDetector(768, 1600);
    return (React.createElement("div", { className: styles.box, style: {
            width: isDesktop ? width || "30%" : "80%",
            maxWidth: "800px",
        } },
        React.createElement("div", { style: {
                display: "flex",
                flex: 1,
                flexGrow: 1,
                flexDirection: "column",
                width: "100%",
            } }, children)));
};
export default Box;
